// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__Vqc40","signatureButtonsRight":"ModalSign_signatureButtonsRight__OFH0c"};